import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-xianxing-chahao",
  "use": "icon-xianxing-chahao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xianxing-chahao\"><path d=\"M812.46234155 153.28265349l58.25500496 58.25500496L570.25500496 512l300.46234155 300.46234155-58.25500496 58.25500496L512 570.25500496l-300.46234155 300.46234155-58.25500496-58.25500496L453.74499504 512 153.28265349 211.53765845 211.53765845 153.28265349 512 453.74499504 812.46234155 153.28265349z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol